import { PathwaySettingsAccess_ProductFragment$key } from "@/admin/pathways/settings/__generated__/PathwaySettingsAccess_ProductFragment.graphql"
import { PathwaySettingsFormStore } from "@/admin/pathways/settings/PathwaySettingsForm"
import ExperienceSettingsAccessSelect from "@/product/settings/ExperienceSettingsAccessSelect"
import { useExperienceSettingsSelectedPlans_membershipPlansFragment$key } from "@/product/settings/hooks/__generated__/useExperienceSettingsSelectedPlans_membershipPlansFragment.graphql"
import ProductSettingsMembershipPlans from "@/product/settings/ProductSettingsMembershipPlans"
import { useAdminProductLabel } from "@/product/util/hook/useProductLabel"
import DiscoFormCollapsibleSection from "@disco-ui/form-collapsible-section/DiscoFormCollapsibleSection"
import { observer } from "mobx-react-lite"
import { graphql, useFragment } from "react-relay"

type Props = {
  form: PathwaySettingsFormStore
  organizationKey: useExperienceSettingsSelectedPlans_membershipPlansFragment$key
  productKey: PathwaySettingsAccess_ProductFragment$key
}

function PathwaySettingsAccess({ form, organizationKey, productKey }: Props) {
  const pathwayLabel = useAdminProductLabel("pathway")

  const product = useFragment<PathwaySettingsAccess_ProductFragment$key>(
    graphql`
      fragment PathwaySettingsAccess_ProductFragment on Product {
        ...ExperienceSettingsAccessSelect_ProductFragment
      }
    `,
    productKey
  )

  return (
    <>
      <DiscoFormCollapsibleSection
        sectionId={"visibility"}
        title={"Visibility"}
        description={`Who can view and enroll in the ${pathwayLabel.singular}`}
        icon={"lock-unlocked"}
        openByDefault
      >
        <DiscoFormCollapsibleSection.Group>
          <ExperienceSettingsAccessSelect
            sublabel={"Select one"}
            form={form}
            productKey={product}
          />
        </DiscoFormCollapsibleSection.Group>
        <ProductSettingsMembershipPlans
          form={form}
          organizationKey={organizationKey}
          productType={"pathway"}
        />
      </DiscoFormCollapsibleSection>
    </>
  )
}

export default observer(PathwaySettingsAccess)
